function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState } from 'react';
import ReactPlayer from 'react-player/youtube';
import MdPlayCircleOutline from '@meronex/icons/md/MdPlayCircleOutline';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import useData from './data';
import BiArrowBack from '@meronex/icons/bi/BiArrowBack';
import { LoadingSpinner } from '../../../Common/LoadingUI';
import Lightbox from 'yet-another-react-lightbox';
import Fullscreen from 'yet-another-react-lightbox/dist/plugins/fullscreen';
import Zoom from 'yet-another-react-lightbox/dist/plugins/zoom';
import 'yet-another-react-lightbox/dist/styles.css';
import ZeroState from '../../../Common/ZeroState';
import Container from '../../../Projects/Components/Container';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export default function EventImageVideoGallery(_ref) {
  var _event$eventGallery, _config$events, _config$events2, _event$displayImage, _event$eventGallery2, _config$events3, _event$eventGallery3;
  var event = _ref.event,
    isLoading = _ref.isLoading,
    config = _ref.config;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    playVideo = _useState2[0],
    setPlayVideo = _useState2[1];
  var params = useParams();
  // const { event, isLoading } = useData(params.eventId);
  var history = useHistory();
  var _useState3 = useState(-1),
    _useState4 = _slicedToArray(_useState3, 2),
    index = _useState4[0],
    setIndex = _useState4[1];
  var eventImages = event === null || event === void 0 || (_event$eventGallery = event.eventGallery) === null || _event$eventGallery === void 0 ? void 0 : _event$eventGallery.map(function (image) {
    var imageDetails = {
      src: image.url
    };
    return imageDetails;
  });
  var backClickHandler = function backClickHandler() {
    history.push('/events?returned=true');
  };
  // console.log(eventImages)
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "\n                    ".concat(config === null || config === void 0 ? void 0 : config.bannerNegativeTopMarginClass, " z-10 w-full ")
    }), (config === null || config === void 0 ? void 0 : config.header) && /*#__PURE__*/_jsx("div", {
      className: config === null || config === void 0 ? void 0 : config.header.headerClass
    }), /*#__PURE__*/_jsxs(Container, {
      className: ' min-h-screen',
      config: config,
      children: [/*#__PURE__*/_jsxs("div", {
        className: "z-10 flex flex-row items-center cursor-pointer",
        onClick: backClickHandler,
        children: [/*#__PURE__*/_jsx(BiArrowBack, {
          className: 'h-16 w-7 ml-8 text-primary z-10'
        }), /*#__PURE__*/_jsx("h3", {
          className: "ml-2 text-primary font-semibold text-lg my-4 z-10   ".concat(config === null || config === void 0 || (_config$events = config.events) === null || _config$events === void 0 ? void 0 : _config$events.fontHeading),
          children: event === null || event === void 0 ? void 0 : event.title
        })]
      }), (event === null || event === void 0 ? void 0 : event.videoUrl) && /*#__PURE__*/_jsxs("div", {
        className: "h-[40vh] md:h-[52vh] lg:h-[58vh] xl:h-[71vh] 2xl:h-[88vh] mx-auto text-center mb-6 lg:mb-16 w-[85%] lg:w-[70%] z-10 flex flex-col",
        children: [/*#__PURE__*/_jsx("h4", {
          className: " text-black font-semibold text-lg my-4 z-10 ".concat(config === null || config === void 0 || (_config$events2 = config.events) === null || _config$events2 === void 0 ? void 0 : _config$events2.fontHeading, "  pt-12 mb-4"),
          children: "EVENT VIDEO"
        }), /*#__PURE__*/_jsx(ReactPlayer, {
          url: event === null || event === void 0 ? void 0 : event.videoUrl,
          className: "react-player border-4 border-primary fixed-bottom self-center w-full z-10",
          playIcon: /*#__PURE__*/_jsx("div", {
            className: "flex relative w-full h-full justify-center ",
            children: /*#__PURE__*/_jsx(MdPlayCircleOutline, {
              className: " absolute self-center text-white text-9xl z-10"
            })
          }),
          playing: playVideo
          // light={true}
          ,
          light: event === null || event === void 0 || (_event$displayImage = event.displayImage) === null || _event$displayImage === void 0 ? void 0 : _event$displayImage.url,
          onClickPreview: function onClickPreview() {
            setPlayVideo(true);
          },
          width: "100%",
          height: "100%",
          controls: true
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "p-8 flex flex-col min-h-screen z-10",
        children: [(event === null || event === void 0 || (_event$eventGallery2 = event.eventGallery) === null || _event$eventGallery2 === void 0 ? void 0 : _event$eventGallery2.length) > 0 && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsxs("div", {
            className: "flex flex-col",
            children: [/*#__PURE__*/_jsx("h4", {
              className: " text-black font-semibold text-lg my-4 z-10 ".concat(config === null || config === void 0 || (_config$events3 = config.events) === null || _config$events3 === void 0 ? void 0 : _config$events3.fontHeading, "  "),
              children: "EVENT PICTURES"
            }), /*#__PURE__*/_jsx("div", {
              className: " grid grid-cols-5 gap-2",
              children: eventImages.map(function (image, i) {
                return /*#__PURE__*/_jsx("img", {
                  onClick: function onClick() {
                    return setIndex(i);
                  },
                  className: " h-full w-full cursor-pointer",
                  src: image === null || image === void 0 ? void 0 : image.src
                });
              })
            })]
          }), /*#__PURE__*/_jsx(Lightbox, {
            slides: eventImages.map(function (image) {
              return {
                src: image === null || image === void 0 ? void 0 : image.src,
                height: null,
                width: null
              };
            }),
            open: index >= 0,
            index: index,
            close: function close() {
              return setIndex(-1);
            },
            plugins: [Fullscreen, Zoom]
          })]
        }), !(event !== null && event !== void 0 && event.videoUrl) && (event === null || event === void 0 || (_event$eventGallery3 = event.eventGallery) === null || _event$eventGallery3 === void 0 ? void 0 : _event$eventGallery3.length) === 0 && /*#__PURE__*/_jsx(ZeroState, {
          type: "events"
        })]
      })]
    })]
  });
}